import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function NearMeDisabledIcon(props: IconProps) {
    return <Icon {...props} iconKey={"near_me_disabled"}/>
}
